"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgMinus(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 6 2", fill: "none", ref: svgRef }, props),
        React.createElement("rect", { x: 0.083, y: 0.417, width: 5.833, height: 1.167, rx: 0.583 })));
}
exports["default"] = React.forwardRef(SvgMinus);
//# sourceMappingURL=Minus.js.map